import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCircleArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"circle-arrow-down, download square, save"} maskId="square-filled-radius-0-stroke-1-IconCircleArrowDown"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 17V16H16V17H8ZM12 14.2071L8.79289 11L9.5 10.2929L11.5 12.2929V7H12.5V12.2929L14.5 10.2929L15.2071 11L12 14.2071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCircleArrowDown;
